import { Flex, type FlexProps } from '@chakra-ui/react'
import React from 'react'

export const ScrollableContent = ({
  children,
  ...rest
}: FlexProps & {
  children: React.ReactNode
}) => {
  return (
    <Flex
      px={8}
      py={6}
      flexDirection="column"
      gap="24px"
      flex="1"
      overflow="auto"
      {...rest}
    >
      {children}
    </Flex>
  )
}
